module.exports = __webpack_public_path__ + "img/r-michelle-tsang-500721-unsplash-min-1200x790.8e137c38.jpg";